import { SchemaField } from '../../../../../../../generic/serialization/schema-field';
import { CommunicationSessionEventLogConferenceSchema } from '../../generic/communication-session-event-log-conference/communication-session-event-log-conference-schema';

export class CommunicationSessionEventLogConferenceParticipantLeaveSchema extends CommunicationSessionEventLogConferenceSchema {
  public static readonly callSid = 'callSid';

  public static readonly coaching = 'coaching';

  public static readonly endConferenceOnExit = 'endConferenceOnExit';

  public static readonly hold = 'hold';

  public static readonly muted = 'muted';

  public static readonly startConferenceOnEnter = 'startConferenceOnEnter';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Constants
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static Defaults = class {
    ///////////////////////////////////////////////////////
    // Generic InboundCallEvent Properties, Copy/Pasted Here
    ///////////////////////////////////////////////////////

    public static readonly type = undefined;

    public static readonly actor = undefined;

    public static readonly timestamp = undefined;

    ///////////////////////////////////////////////////////
    // CommunicationSessionEventLogConference Properties
    ///////////////////////////////////////////////////////

    public static readonly conferenceEventType = undefined;

    public static readonly conferenceSid = undefined;

    public static readonly eventTimestamp = undefined;

    public static readonly friendlyName = undefined;

    public static readonly sequenceNumber = undefined;

    ///////////////////////////////////////////////////////
    // Participant Leave Properties
    ///////////////////////////////////////////////////////

    public static readonly callSid = undefined;

    public static readonly coaching = undefined;

    public static readonly endConferenceOnExit = undefined;

    public static readonly hold = undefined;

    public static readonly muted = undefined;

    public static readonly startConferenceOnEnter = undefined;
  };

  public defaultValuesToSerialize(): Set<string> {
    return new Set([]);
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Definition
  ////////////////////////////////////////////////////////////////////////////////////////////////

  /**
   * Schema for this object is encoded into a command name, and in parameters
   */
  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } {
    const parameters = super.getSchemaDefinition();

    /* eslint-disable */
    parameters[CommunicationSessionEventLogConferenceParticipantLeaveSchema.callSid] = SchemaField.string(
      CommunicationSessionEventLogConferenceParticipantLeaveSchema.Defaults.callSid,
    ).required();
    parameters[CommunicationSessionEventLogConferenceParticipantLeaveSchema.coaching] = SchemaField.boolean(
      CommunicationSessionEventLogConferenceParticipantLeaveSchema.Defaults.coaching,
    ).required();
    parameters[CommunicationSessionEventLogConferenceParticipantLeaveSchema.endConferenceOnExit] = SchemaField.boolean(
      CommunicationSessionEventLogConferenceParticipantLeaveSchema.Defaults.endConferenceOnExit,
    ).required();
    parameters[CommunicationSessionEventLogConferenceParticipantLeaveSchema.hold] = SchemaField.boolean(
      CommunicationSessionEventLogConferenceParticipantLeaveSchema.Defaults.hold,
    ).required();
    parameters[CommunicationSessionEventLogConferenceParticipantLeaveSchema.muted] = SchemaField.boolean(
      CommunicationSessionEventLogConferenceParticipantLeaveSchema.Defaults.muted,
    ).required();
    parameters[CommunicationSessionEventLogConferenceParticipantLeaveSchema.startConferenceOnEnter] =
      SchemaField.boolean(
        CommunicationSessionEventLogConferenceParticipantLeaveSchema.Defaults.startConferenceOnEnter,
      ).required();
    /* eslint-enable */

    return parameters;
  }
}
